/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
/* eslint-disable no-trailing-spaces */
/* eslint-disable */
import React, { useState } from 'react';
import { IoCall } from 'react-icons/io5';
import notification from './notification';
import { MdCall } from 'react-icons/md';

function PhoneCallButton({ phoneNumber, buttonText = "Need Help?", className = "" }) {
    const [showCopiedMessage, setShowCopiedMessage] = useState(false);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(phoneNumber).then(() => {
            notification({
                type: "success",
                title: "Phone number copied",
                description: `${phoneNumber} copied to clipboard`,
            });
        });
    };

    const handleClick = () => {
        const mailtoLink = `tel:${phoneNumber}`;
        window.location.href = mailtoLink;

        setTimeout(() => {
            if (document.hasFocus()) {
                // If document still has focus after trying to open the tel: link,
                // it likely means we're on desktop and the link didn't open a phone app
                copyToClipboard();
            }
        }, 300);
    };

    return (
        <div className={`text-black md:text-[15px] font-[Poppins] font-semibold flex flex-wrap items-end justify-end md:pt-0 pt-4 gap-2 ${className} w-full md:fit items-center`}>
            <button
                onClick={handleClick}
                // className="flex flex-col items-left text-red-500  hover:text-red-600 text-sm"
                className="flex flex-wrap gap-1.5 items-left text-red-500  hover:text-red-600 text-sm"
            >
                <MdCall className='text-[18px]' />
                {/* <p>
                    For Contrast MRI's and
                </p>
                <p>
                    General Information Please call
                </p> */}
                {/* <p className="md:text-lg"> */}
                <p className="md:text-[18px] text-[15px]">
                    Need Help? Call 
                </p>
            </button>
            {/* <button onClick={handleClick} className="text-red-500 text-lg">{phoneNumber}</button> */}
            <button onClick={handleClick} className="text-red-500 md:text-[18px] text-[15px]">{phoneNumber}</button>
            {/* {phoneNumber} */}
        </div>
    );
}

export default PhoneCallButton;
